import { useEffect, useRef, useCallback } from 'react';
const IDLE_EVENTS = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll'];
export const useIdleTimeout = ({ timeout, onIdle, onActive, debounce = 200, }) => {
    const idleTimer = useRef(null);
    const activityTimer = useRef(null);
    const resetTimer = useCallback(() => {
        if (idleTimer.current) {
            clearTimeout(idleTimer.current);
        }
        idleTimer.current = setTimeout(() => {
            onIdle();
        }, timeout);
    }, [timeout, onIdle]);
    const handleUserActivity = useCallback(() => {
        if (activityTimer.current) {
            clearTimeout(activityTimer.current);
        }
        activityTimer.current = setTimeout(() => {
            resetTimer();
            onActive?.();
        }, debounce);
    }, [debounce, onActive, resetTimer]);
    useEffect(() => {
        resetTimer();
        IDLE_EVENTS.forEach(event => {
            window.addEventListener(event, handleUserActivity);
        });
        return () => {
            if (idleTimer.current) {
                clearTimeout(idleTimer.current);
            }
            if (activityTimer.current) {
                clearTimeout(activityTimer.current);
            }
            IDLE_EVENTS.forEach(event => {
                window.removeEventListener(event, handleUserActivity);
            });
        };
    }, [resetTimer, handleUserActivity]);
};
